export const validUsername = new RegExp('^([a-zA-Z0-9_]){3,26}$');
export const validName = new RegExp('^( )*[a-zA-Z.]+( )?[a-zA-Z]+( )*$');
export const validEmail = new RegExp('^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$');
export const validPassword = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&<>\.'";:(){}[\],_|=`~\/+-])[A-Za-z\d@$!%*#?&<>\.'";:(){}[\],_|=`~\/+-]{8,}$/;
export const USZipCodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;